<template>
 <ReportDashBoard/>
</template>
<script>
  import Layout from '../components/Layout'
  import ReportDashBoard from '../components/ReportDashboard'
  
  export default {
    components: {
      Layout,
      ReportDashBoard
    }
  }
</script>
